import { OverlayModule } from '@angular/cdk/overlay';

import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { map } from 'rxjs';

import { VersionService } from './version.service';

@Component({
  selector: 'app-main-layout',
  imports: [RouterModule, OverlayModule],
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {
  readonly #versionService = inject(VersionService);

  aideEstOuvert = signal<boolean>(false);
  version$ = this.#versionService.getVersion().pipe(map((version) => `Version ${version.split(/[+-]/)[0]}`));

  toggleAide() {
    this.aideEstOuvert.set(!this.aideEstOuvert());
  }
}
